import React from 'react';
import BasicStep from './BasicStep';
import Styles from "../../styles/Styles";
import Config from "../../config"

export default class Order extends BasicStep {
  constructor(props) {
    super(props);

    this.state = {
      packs: props.getStore().pharmacy.order.packs,
      hasPack: props.getStore().pharmacy.order.hasPack,
      hasEmail: props.getStore().pharmacy.order.hasEmail,
      hasSms: props.getStore().pharmacy.order.hasSms,
      hasMail: props.getStore().pharmacy.order.hasMail,
      validationErrors : {},
      total: 0,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeOrder = this.handleChangeOrder.bind(this);
  }

  componentDidMount() {
    this.updateTotal(); 
  }

  componentWillUnmount() {}

  handleChange(event) {
    const name = event.target.name;

    // If value is equal to on thus the element is a checkbox
    // so we get the checked value
    var value = event.target.value;
    if (value === "on") {
      value = event.target.checked
    }
  
    // Update the businessHour object
    //responsibles[index][key] = value;
    this.setState({
      [name]: value
    });
  }

  handleChangeOrder(event) {
    var packs = this.state.packs;
    const name = event.target.name;

    let key = name.split("-")[0];
    let index = name.split("-")[1];
    
    // If value is equal to on thus the element is a checkbox
    // so we get the checked value
    var value = event.target.value;
    if (value === "on") {
      value = event.target.checked
    }

    // Update the pack object
    packs[index][key] = value;

    this.setState({
      packs: packs
    }, this.updateTotal());
  }

  /**
   * Update the total of order
   */
  updateTotal() {
    let total = 0;

    this.state.packs.forEach(element => {
      total += element.price * element.quantity ;
    });

    this.setState({
      total: total
    });
  }

  isValidated() {
    return new Promise((resolve, reject) => {
      const hasError = !this.checkForm();

      if (hasError) {
        reject(); // form contains errors
        return;
      }

      this.props.updateStore({
          ...this.getValidatorData(),
          savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
      });  // Update store here (this is just an example, in reality you will do it via redux or flux)


        resolve();
    });
  }
  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }


  checkForm(){
    if (this.state.total !== 0){
      this.setState({validationErrors:{}});
      return true;
    }
    else {
      this.setState({validationErrors:{
        "packs" : "Vous devez commander à minima un pack"
        }});
      return false;
    }
  }

  getValidatorData() {
    var object = this.props.getStore();
    object.pharmacy.order.packs = this.state.packs;
    object.pharmacy.order.hasPack = this.state.hasPack;
    object.pharmacy.order.hasEmail = this.state.hasEmail;
    object.pharmacy.order.hasSms = this.state.hasSms;
    object.pharmacy.order.hasMail = this.state.hasMail;

    return object;
  }


  renderItemView(pack, index) {
    return (
      <div className="card card-use-margin" key={index}>
        <h4 style={Styles.Style.bgColorMain} className="card-heading margin-bottom-l">
          { pack.name }
          <label className="price">{ pack.price + " € H.T"}</label>
        </h4>
        <div className="card-body">
          <div className="card-body-center">
            <label className="label-big">Quantité</label>
            <input name={"quantity-" + index} type="number" min="0" placeholder="quantity" className={"textbox-light textbox-light-program-"+Config.program.style} onChange={this.handleChangeOrder} defaultValue={pack.quantity}/>
          </div>
        </div>
      </div>
    )
  }

  renderTotalView() {
    return (
      <div className="total">
        {"Total : " + this.state.total + " € H.T"}
      </div>
    );
  }


  render() {
    const packs = this.state.packs.map(
        (pack, index) => this.renderItemView(pack, index)
    );
    return (
      <div className="step step3">
        <form className="form">
          <fieldset className="form-fieldset">
            <legend className="form-fieldset-legend">Commande pack de carte</legend>


            { (this.state.hasPack) ? packs : <div></div>}
            { (this.state.hasPack) ? this.renderTotalView() : <div></div>}
            <span className="form-error">{this.errorFor("packs")}</span>
          </fieldset>
        </form>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Steps/Order.js